import ConstructionEquipment from "./ConstructionEquipment";

export default ConstructionEquipment;
